import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  private readonly baseUrl = 'http://localhost:3300';

  constructor(private readonly http: HttpClient) { }

  public get(url: string): Observable<any> {
    const headers = new HttpHeaders();
    headers.append('withCredentials', 'true');
    return this.http.get(`${this.baseUrl}/${url}`, { headers });
  }

  public post<T>(url: string, body: T): Observable<any> {
    const headers = new HttpHeaders();
    headers.append('withCredentials', 'true');
    return this.http.post(`${this.baseUrl}/${url}`, body, { headers });
  }

  public put<T>(url: string, body: T): Observable<any> {
    const headers = new HttpHeaders();
    headers.append('withCredentials', 'true');
    return this.http.put(`${this.baseUrl}/${url}`, body, { headers });
  }

  public patch<T>(url: string, body: T): Observable<any> {
    const headers = new HttpHeaders();
    headers.append('withCredentials', 'true');
    return this.http.patch(`${this.baseUrl}/${url}`, body, { headers });
  }

  public delete(url: string): Observable<any> {
    const headers = new HttpHeaders();
    headers.append('withCredentials', 'true');
    return this.http.delete(`${this.baseUrl}/${url}`, { headers });
  }
}
